class LanguageSwitcher {
  public toggle: NodeListOf<HTMLInputElement>;
  public switcherModal: HTMLElement | null;
  public close: HTMLElement | null;
  public languageInputs: NodeListOf<HTMLInputElement> | null;
  public deliveryCountryForm: HTMLFormElement | null;

  bindings() {
    this.toggle.forEach((el) => {
      el.addEventListener('click', (e) => {
        e.preventDefault();

        this.switcherModal?.classList.toggle('is-active');
        document.body.classList.toggle('lang-is-open');
      });
    });

    this.close?.addEventListener('click', (e) => {
      e.preventDefault();

      this.switcherModal?.classList.remove('is-active');
      document.body.classList.remove('lang-is-open');
    });

    this.languageInputs?.forEach((languageInput: HTMLInputElement) => {
      languageInput.addEventListener('click', () => {
        if(languageInput.dataset.langiso === 'de-CH') {
          const chDeliveryCountry = this.deliveryCountryForm?.querySelector('input[id="country-215"]') as HTMLInputElement;
          chDeliveryCountry?.click();
        } else {
          window.location.replace(languageInput.value);
        }
      });
    });

    if (this.deliveryCountryForm) {
      const paymentCurrencyInput: HTMLInputElement | null = this.deliveryCountryForm.querySelector('input[name="paymentCurrency"]');
      const currencyInput: HTMLInputElement | null = this.deliveryCountryForm.querySelector('input[name="currency"]');
      const countries: NodeListOf<HTMLInputElement> | null = this.deliveryCountryForm.querySelectorAll('input[type="radio"]');

      if (countries) {
        countries.forEach((country: HTMLInputElement) => {
          country.addEventListener('click', (e: Event) => {
            if (currencyInput && paymentCurrencyInput) {
              const currentTarget = e.currentTarget as HTMLInputElement;

              if (currentTarget && currentTarget.dataset.currency) {
                // @ts-ignore
                currencyInput.value = currentTarget.dataset.currency;
                paymentCurrencyInput.value = currentTarget.dataset.currency;
              }
            }

            const countryLangIso = country.getAttribute('data-langiso');
            this.languageInputs?.forEach((languageInput: HTMLInputElement) => {
              const langiso = languageInput.getAttribute('data-langiso') || '';
              if (countryLangIso == langiso) {
                const nextURL = languageInput.value;
                window.history.replaceState(null, '', nextURL);
              }
            });

            // @ts-ignore
            this.deliveryCountryForm.submit();
          });
        });
      }
    }

    // ヽ(ー_ー )ノ
    document.addEventListener('keydown', (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        if (this.switcherModal && this.switcherModal.classList.contains('is-active')) {
          this.switcherModal.classList.remove('is-active');
          document.body.classList.remove('lang-is-open');
        }
      }
    });
  }

  cache() {
    this.toggle = document.querySelectorAll('.js-ls-toggle');
    this.switcherModal = document.querySelector('.js-ls');
    this.close = document.querySelector('.js-ls-close');
    this.languageInputs = document.querySelectorAll('.js-ls-language');
    this.deliveryCountryForm = document.querySelector('.js-ls-delivery-country-form');
  }

  init() {
    this.cache();
    this.bindings();
  }
}

export default LanguageSwitcher;
